

export const getSystem = function () {
    const na = navigator.userAgent.toLowerCase()
    const system = {
        isWeixin: na.indexOf('micromessenger') > -1,
        isQQ: na.indexOf('qq/') > -1,
        isJr: na.indexOf('jdjr-app') > -1,
        isJd: na.indexOf('jdapp') > -1,
        isIos: na.indexOf('iphone') > -1,
        isAndroid: na.indexOf('android') > -1,
        isIphoneX: /iphone/gi.test(navigator.userAgent) && (window.screen.height === 812 && window.screen.width === 375)
            || /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3
            && window.screen.width === 414 && window.screen.height === 896
            || /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2
            && window.screen.width === 414 && window.screen.height === 896

    }
    return system
}
// export function resetPageUrl(url, params) {
//     let urlStr = url;
//     let a = window.location.pathname
//     let b = window.location.host
//     let c = window.location.protocol
//     if (params) {
//         let nParamsStr = parseToUrl(params, null, 'UTF-8');
//         if (nParamsStr.startsWith("&")) {
//             nParamsStr = nParamsStr.substring(1, nParamsStr.length);
//         }
//         window.console.log("参数---", nParamsStr)
//         if (nParamsStr == "") {
//             urlStr = `${c}//${b}${a}#${url}`
//         } else {
//             urlStr = `${c}//${b}${a}?${nParamsStr}#${url}`
//         }
//     } else {
//         urlStr = `${c}//${b}${a}#${url}`
//     }
//     return urlStr;
// }
export function resetPageUrl(url, params) {
    url = `/release/bbf${url}`;
    let urlStr = url;
    let a = window.location.pathname
    let b = window.location.host
    let c = window.location.protocol
    if (params) {
        let nParamsStr = parseToUrl(params, null, 'UTF-8');
        if (nParamsStr.startsWith("&")) {
            nParamsStr = nParamsStr.substring(1, nParamsStr.length);
        }
        window.console.log("参数---", nParamsStr)
        if (nParamsStr == "") {
            urlStr = `${c}//${b}${url}`
        } else {
            urlStr = `${c}//${b}${url}?${nParamsStr}`
        }
    } else {
        urlStr = `${c}//${b}${url}`
    }
    return urlStr;
}
//  home键的返回，导航的返回ios监听不了
export const getVisibility = function() {
    var hidden, visibilityChange;
    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document.mozHidden !== 'undefined') {
      hidden = 'mozHidden';
      visibilityChange = 'mozvisibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }
    return {
      hidden,
      visibilityChange
    };
  };
  
  // 当前标签页是否激活
  export const visibilityPage = function(cb, addListener) {
    var { hidden, visibilityChange } = getVisibility();
  
    if (
      typeof document.addEventListener === 'undefined' ||
      typeof document[hidden] === 'undefined'
    ) {
    } else {
      // 处理页面可见属性的改变
      if (addListener) {
        document.addEventListener(visibilityChange, cb, false);
      } else {
        document.removeEventListener(visibilityChange, cb);
      }
    }
  };
  
  export const visibilityState = function() {
    var { hidden } = getVisibility();
    //return !document[hidden];
  };
/**
 * 将参数对象转URL
 * @param params 参数对象
 * @param key 指定key
 * @param 编码
 * */
export function parseToUrl(params, key, encode) {
    if (!params) return "";
    let urlStr = "";
    let type = typeof (params);
    if (type === 'string' || type === 'number' || type === 'boolean') {
        urlStr += '&' + key + '=' + ((encode == null || encode) ? params : params);
    } else {
        for (let i in params) {
            let k = key == null ? i : key + (params instanceof Array ? '[' + i + ']' : '.' + i);
            urlStr += parseToUrl(params[i], k, encode);
        }
    }
    return urlStr;
}
export function GetRequest(key) {
    //key存在先通过search取值如果取不到就通过hash来取
    let after = window.location.search.substr(1) || window.location.hash.split("?")[1];
    if (after) {
        let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
        let r = after.match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        } else {
            return null;
        }
    }
}

//m 1 天转换为毫秒  2毫秒转换为天
export function dayMill(v, m) {
    if (m === 1) {
        return v * 24 * 60 * 60 * 1000;
    } else {
        return Math.ceil(v / 24 / 60 / 60 / 1000);
    }
}

//获取风控信息
export const getFengkongData = function () {
    let riskMap = {}
    try {
        const risk_jd = window.getEidJoint();

        riskMap = {
            ip: risk_jd.ip,
            eid: risk_jd.eid,
            imei: risk_jd.im,
            openUUID: risk_jd.ou,
            sdkToken: risk_jd.sto,
            appType: risk_jd.at,
        }
    } catch (e) { }
    return riskMap
}

//监控页面显示隐藏
export function listenPageStatus (callback) {
    let hiddenProperty = null
  
    if ('hidden' in document) {
        hiddenProperty = 'hidden'
    } else if ('webkitHidden' in document) {
        hiddenProperty = 'webkitHidden'
    } else if ('mozHidden' in document) {
        hiddenProperty = 'mozHidden'
    }
  
    document.addEventListener('visibilitychange', () => {
        if (callback) {
            callback(!document[hiddenProperty])
        }
    })
  }
//status 转换

export const statusChange = function (info, time) {
    let t = {
        mask: 'ac1',
        listText: '继续完成',
        homeTitleText: '活动时间',
        homeBtnText: '去攒更多',
        homeBack: false,
    };
    const taskBeginTime = info.taskBeginTime;
    const taskEndTime = info.taskEndTime;
    const rewardStartTime = taskEndTime + dayMill(info.frozenTime || 0, 1) + 1000;
    const rewardEndTime = rewardStartTime + dayMill(info.rewardDeadline || 0, 1) - 1000;
    const listDayText = `${dayMill(rewardStartTime - time)}日后领奖`;
    let showTime = null;
    //未开始
    if (info.status === 10 || time < taskBeginTime) {
        t = {
            ...t,
            mask: 'no',
            listText: '未开始',
            listSty: 'list-btn-dis2',
            listCls: 'rwlist|an-rwwks',
            homeTitleText: '活动时间',
            stime: taskBeginTime,
            etime: taskEndTime,
            homeBtnText: '去看看其它活动',
            homeBtnCls: '',
            homeBack: true,
            homeBackText: '活动正在准备中哦~',
            pastBtnCls: '',
            
        }
    }
    
    //活动期
    else if (time > taskBeginTime && time <= taskEndTime) {
        //未领取  接风控
        if (info.status === 0) {
            t = {
                ...t,
                mask: 'ac0',
                listText: '领取任务',
                listSty: 'list-btn-fill',
                listCls: 'rwlist|an-lqjl',
                homeBtnText: '开启活动',
                homeBtnCls: 'rwxqy|an-kqhd',
                pastBtnCls: 'wqrwlist|an-lqjl',
            }
        }
        //领取未达标
        if (info.status === 1) {
            t = {
                ...t,
                mask: 'ac1',
                listText: '继续完成',
                listSty: '',
                listCls: 'rwlist|an-jxwc',
                homeBtnText: '去攒更多',
                homeBtnCls: 'rwxqy|an-qzgdje',
                pastBtnCls: 'wqrwlist|an-jxwc',
            }
        }
        //达标未到领奖期
        if (info.status === 2 || info.status === 4) {
            t = {
                ...t,
                mask: 'ac2',
                listText: listDayText,
                listSty: '',
                listCls: 'rwlist|an-XXklj',
                homeBtnText: `${new Date(rewardStartTime).format('M月d日')}可领奖`,
                homeBtnCls: 'rwxqy|an-XXklj',
                pastBtnCls: 'wqrwlist|an-XXklj',
            }
        }
        t = {
            ...t,
            homeTitleText: '活动时间',
            stime: taskBeginTime,
            etime: taskEndTime
        }
    }
    //冻结期  大于活动结束时间，小于领奖开始时间
    else if (time > taskEndTime && time <= rewardStartTime) {
        //未领取活动  未参与
        if (info.status === 0) {
            t = {
                ...t,
                mask: 'fr0',
                listText: '未参与',
                listSty: 'list-btn-dis2',
                listCls: 'rwlist|an-wwc',
                homeBtnText: '去看看其它活动',
                homeBtnCls: '',
                homeBack: true,
                homeBackText: '抱歉，您已错过活动报名时间~',
                pastBtnCls: 'wqrwlist|an-wwc',
            }
        }
        //未完成
        if (info.status === 1) {
            t = {
                ...t,
                mask: 'fr1',
                listText: '未完成',
                listSty: 'list-btn-dis2',
                listCls: 'rwlist|an-wwc',
                homeBtnText: '未完成',
                homeBtnCls: 'rwxqy|an-wwc',
                pastBtnCls: 'wqrwlist|an-wwc',
            }
        }
        //达标未到领奖期
        if (info.status === 2 || info.status === 4) {
            t = {
                ...t,
                mask: 'fr2',
                listText: listDayText,
                listSty: '',
                listCls: 'rwlist|an-XXklj',
                homeBtnText: `${new Date(rewardStartTime).format('M月d日')}可领奖`,
                homeBtnCls: 'rwxqy|an-XXklj',
                pastBtnCls: 'wqrwlist|an-XXklj',
            }
        }
        t = {
            ...t,
            homeTitleText: '冻结时间',
            stime: taskEndTime + 1000,
            etime: taskEndTime + dayMill(info.frozenTime || 0, 1)
        }
    }
    //领奖期
    else if (time > rewardStartTime && time <= rewardEndTime) {
        //未领取活动  未参与
        if (info.status === 0) {
            t = {
                ...t,
                mask: 'rw0',
                listText: '未参与',
                listSty: 'list-btn-dis2',
                listCls: 'rwlist|an-wwc',
                homeBtnText: '去看看其它活动',
                homeBtnCls: '',
                homeBack: true,
                homeBackText: '抱歉，您已错过活动报名时间~',
                pastBtnCls: 'wqrwlist|an-wwc',
            }
        }
        //未完成
        if (info.status === 1) {
            t = {
                ...t,
                mask: 'rw1',
                listText: '未完成',
                listSty: 'list-btn-dis2',
                listCls: 'rwlist|an-wwc',
                homeBtnText: '未完成',
                homeBtnCls: 'rwxqy|an-wwc',
                pastBtnCls: 'wqrwlist|an-wwc',
            }
        }
        //可领奖  接风控
        if (info.status === 2) {
            t = {
                ...t,
                mask: 'rw2',
                listText: '去领奖',
                listSty: 'list-btn-fill',
                listCls: 'rwlist|an-lqjl',
                homeBtnText: '领取奖励',
                homeBtnCls: 'rwxqy|an-lqjl',
                pastBtnCls: 'wqrwlist|an-lqjl',
            }
        }
        //查看奖励
        if (info.status === 4) {
            t = {
                mask: 'rw4',
                listText: '查看奖励',
                listSty: 'list-btn-fill',
                listCls: 'rwlist|an-ckjl',
                homeBtnText: '查看奖励',
                homeBtnCls: 'rwxqy|an-ckjl',
                pastBtnCls: 'wqrwlist|an-ckjl',
            }
        }
        t = {
            ...t,
            homeTitleText: '领奖时间',
            stime: rewardStartTime,
            etime: rewardEndTime
        }
    }
    //领奖期外
    else if (time > rewardEndTime) {
        //未领取活动  未参与
        if (info.status === 0) {
            t = {
                mask: 'ou0',
                listText: '未参与',
                listSty: 'list-btn-dis2',
                listCls: 'rwlist|an-wwc',
                homeBtnText: '去看看其它活动',
                homeBtnCls: '',
                homeBack: true,
                homeBackText: '抱歉，您已错过活动报名时间~',
                pastBtnCls: 'wqrwlist|an-wwc',
            }
        }
        //未完成
        if (info.status === 1) {
            t = {
                mask: 'ou1',
                listText: '未完成',
                listSty: 'list-btn-dis2',
                listCls: 'rwlist|an-wwc',
                homeBtnText: '活动已结束',
                homeBtnCls: 'rwxqy|an-wwc',
                pastBtnCls: 'wqrwlist|an-wwc',
            }
        }
        //未领奖
        if (info.status === 2) {
            t = {
                mask: 'ou2',
                listText: '未领奖',
                listSty: 'list-btn-dis2',
                listCls: 'rwlist|an-wwc',
                homeBtnText: '活动已结束',
                homeBtnCls: 'rwxqy|an-wwc',
                pastBtnCls: '',
            }
        }
        //已完成
        if (info.status === 4) {
            t = {
                mask: 'ou4',
                listText: '已完成',
                listSty: 'list-btn-dis2',
                listCls: 'rwlist|an-wwc',
                homeBtnText: '活动已结束',
                homeBtnCls: 'rwxqy|an-wwc',
                pastBtnCls: '',
            }
        }
        t = {
            ...t,
            homeTitleText: '领奖时间',
            stime: rewardStartTime,
            etime: rewardEndTime
        }
    } else {
        console.log('err')
    }
    if(info.page === 'list') {
        showTime = new Date(t.stime).format('yyyy.M.d') + '-' + new Date(t.etime).format('M.d');
    }else if(info.page === 'home'){
        showTime = new Date(t.stime).format('yyyy.M.d') + '-' + new Date(t.etime).format('yyyy.M.d');
    }else if(info.page === 'past'){
        showTime = new Date(t.stime).format('yyyy.M.d') + '-' + new Date(t.etime).format('M.d');
    }
    return {
        ...t,
        rewardStartTime,
        rewardEndTime,
        listDayText,
        showTime
    }
}
